import { analytics } from "@/lib/analytics";
import { sanitizePathname } from "@/lib/analytics/error-utils";
import { findNavigationItem } from "@/routers/utils";

let hasTrackedNavigation = false;

const trackNavigationMetrics = () => {
  const entries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
  const nav = entries[0];
  if (!nav) return;

  const pathname = window.location.pathname;
  const navItem = findNavigationItem(pathname);
  const routePath = navItem?.path || sanitizePathname(pathname);
  const commonMeta = {
    route_path: routePath,
    navigation_type: nav.type,
  };

  const metrics = [
    { name: "navigation.ttfb", duration: nav.responseStart },
    { name: "navigation.dom_interactive", duration: nav.domInteractive },
    { name: "navigation.dom_content_loaded", duration: nav.domContentLoadedEventEnd },
    { name: "navigation.load_event", duration: nav.loadEventEnd },
  ];

  metrics.forEach((metric) => {
    if (Number.isFinite(metric.duration) && metric.duration > 0) {
      analytics.trackPerformance({
        metricName: metric.name,
        duration: metric.duration,
        metadata: commonMeta,
      });
    }
  });
};

export const trackInitialNavigationPerformance = () => {
  if (hasTrackedNavigation) return;
  if (typeof window === "undefined" || typeof performance === "undefined") return;

  const run = () => {
    if (hasTrackedNavigation) return;
    hasTrackedNavigation = true;
    trackNavigationMetrics();
  };

  if (document.readyState === "complete") {
    setTimeout(run, 0);
  } else {
    window.addEventListener("load", run, { once: true });
  }
};
